import Chart from "react-apexcharts";
import { Loading } from "../../../componentes/loading/loading";

export function ErrosVsAcertos({ report, loading }) {
  const totalErros = Number(report.totalErros || 0);
  const totalCaixas = Number(report.totalCaixas || 0);

  const percentualErros = totalCaixas > 0 ? (totalErros / totalCaixas) * 100 : 0;
  const percentualAcertos = 100 - percentualErros;

  const options = {
    chart: {
      type: "donut",
    },
    labels: ["Erros", "Acertos"],
    legend: {
      position: "bottom",
    },
    stroke: {
      show: false,
      width: 0,
    },
    plotOptions: {
      pie: {
        donut: {
          size: "65%",
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: "14px",
            },
          
            total: {
              show: true,
              label: "Taxa de Erro",
              fontSize: "18px",
              formatter: () =>
                `${percentualErros.toFixed(2)}%`,
            },
          },
        },
      },
    },
    colors: ["#EF4444", "#10B981"],
    tooltip: {
      y: {
        formatter: (val) => `${val.toFixed(2)}%`,
      },
    },
    
  };

  const series = [percentualErros, percentualAcertos];

  return (
      <div style={{ height: 320 }}>
        {!loading ? (
          <Chart options={options} series={series} type="donut" height="100%" />
        ) : (
          <Loading />
        )}
    </div>
  );
}